import React, { useState } from 'react';

import PromptEditor from '../PromptEditor';
import { PromptLanguage } from '../PromptEditor/const';
import CodeEditorExpandable from '../CodeEditorExpandable';
import { CodeEditorSize } from '../CodeEditorExpandable/types';
import { getDefaultIfUndefined } from '../../../utils/typeUtil';
import { CodeEditorStatus } from '../CodeEditor/types';
import { DEFAULT_EDITOR_STATUS } from '../CodeEditor/const';

import { DEFAULT_EDITOR_SIZE } from './const';

export interface IPromptEditorExpandableProps {
  className?: string;
  value?: null | string | number;
  size?: CodeEditorSize;
  status?: CodeEditorStatus;
  readOnly?: boolean;
  promptLanguage: PromptLanguage;
  onChange?: (value: string) => void;
  onBlur?: () => void;
}

const PromptEditorExpandable: React.FC<IPromptEditorExpandableProps> = ({
  className,
  value,
  size = DEFAULT_EDITOR_SIZE,
  status = DEFAULT_EDITOR_STATUS,
  readOnly,
  promptLanguage,
  onChange,
  onBlur,
}) => {
  size = getDefaultIfUndefined(size, DEFAULT_EDITOR_SIZE);

  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <CodeEditorExpandable
      className={className}
      isFullscreen={isFullscreen}
      readOnly={readOnly}
      size={size}
      status={status}
      onFullscreenToggle={setIsFullscreen}
    >
      <PromptEditor
        isFullscreen={isFullscreen}
        promptLanguage={promptLanguage}
        readOnly={readOnly}
        value={(value as string) ?? ''}
        onBlur={onBlur}
        onChange={onChange}
      />
    </CodeEditorExpandable>
  );
};

export default PromptEditorExpandable;
